/**
 * useCurrentAction - Shared hook for managing current action state
 *
 * Provides centralized state management for action blocking mechanic.
 * Now consumes CurrentActionContext to ensure global synchronization.
 */

import { useCurrentActionContext } from '../contexts/CurrentActionContext'

export const useCurrentAction = () => {
  return useCurrentActionContext()
}
